import { Component, Input, OnInit } from '@angular/core';
import { Signal } from 'src/app/shared/model/signal';
import { ActivityService } from 'src/app/shared/services/activity.service';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-worldwatch-carousel',
  templateUrl: './worldwatch-carousel.component.html',
  styleUrls: ['./worldwatch-carousel.component.scss']
})
export class WorldwatchCarouselComponent implements OnInit {

  @Input()
  latestSignals?: Signal[];

  @Input()
  loadedSignals: boolean;

  constructor(
    private activitySearch: ActivityService,
     private alertService: AlertService
  ) { }

  ngOnInit(): void {
    // load the latest activity and save the latest signals in session storage
    // for use in the signals list
    this.activitySearch.loadActivityDays(7, true)
      .then(res => {
        this.latestSignals = JSON.parse(sessionStorage.getItem('latestSignals'));

        this.latestSignals = this?.latestSignals.map(item => {
          item.publishDateObj = new Date(item.publishDate);
          return item;
        });
        this.loadedSignals = true;
      })
      .catch(err => {
        delete this.latestSignals;
        this.loadedSignals = false;
        this.alertService.handlerError(err);
      });
  }

}
